var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopUpPlanGenericIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C20 32 20.5 33.84 21.34 35.48L20 36.7L17.1 34.06C6.8 24.72 0 18.54 0 11C0 4.82 4.84 0 11 0C14.48 0 17.82 1.62 20 4.16C22.18 1.62 25.52 0 29 0C35.16 0 40 4.82 40 11C40 13.86 39 16.52 37.24 19.22C35.66 18.46 33.88 18 32 18C25.38 18 20 23.38 20 30ZM34 22H30V28H24V32H30V38H34V32H40V28H34V22Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpPlanGenericIcon);
export default __webpack_public_path__ + "static/media/TopUpPlanGenericIcon.79619f018ebb8652771f65f34a7db47b.svg";
export { ForwardRef as ReactComponent };